import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';
import { ConfirmationDialogService } from '../confirmation-dialog/confirmation-dialog.service';
import { ToastrService } from 'ngx-toastr';
import { ComponentCanDeactivate } from '../PendingChangesGuard ';
import { ImportemployeeComponent } from './importemployee/importemployee.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EmpfilterComponent } from '../grid/empfilter/empfilter.component';
import { DatePipe } from '@angular/common';
import moment from 'moment';
import { ExportgridComponent } from '../grid/exportgrid/exportgrid.component';
import { ExcelService } from 'src/app/services/services/excel.service';

@Component({
  selector: 'app-emp',
  templateUrl: './emp.component.html',
  styleUrls: ['./emp.component.css']
})
export class EmpComponent implements OnInit {

  @ViewChild('filterbar', { static: false }) filterbar;

  isadd: boolean = false;
  isedit: boolean = false;
  isdelete: boolean = false;
  isview: boolean = false;
  isprint: boolean = false;
  isexport: boolean = false;
  isfilter: boolean = false;


  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;


  formname: string = "Employee";


  gridformtype: string = "";

  filteremployeeid: any = null;
  filteremployeename: any = null;
  filterdesignationid: any = null;
  filterdesignationname: any = null;
  filterpayrollgrpid: any = null;
  filterpayrollgrpname: any = null;
  filterbranchid: any = null;
  filterbranchname: any = null;
  filterdepartmentid: any = null;
  filterdepartmentname: any = null;
  filterlocationid: any = null;
  filterlocationname: any = null;
  filternationalityid: any = null;
  filternationality: any = null;
  filterfromdate: any = null;
  filtertodate: any = null;

  checkemp: string = "";
  companycheckColl: any = [];
  filterstatus: string = "ALL";
  empColl: any = [];




  searchtxt: any = "";
  columnDefs = [
    { headerName: 'Code', field: 'staffcode' },
    { headerName: 'EmployeeName', field: 'empname', width: 300, minWidth: 300 },
    { headerName: 'Designation', field: 'designationname' },
    { headerName: 'Branch', field: 'branchname', width: 300, minWidth: 300 },
    { headerName: 'Department', field: 'departmentname', width: 300, minWidth: 300 },
    { headerName: 'Status', field: 'empstatus', width: 300, minWidth: 300 },

  ]

  gridOptions = {
    enableactioncol: true,
    columnDefs: this.columnDefs,
    pageindex: 1
  };

  constructor(private excelService: ExcelService, private appService: AppdataService, private loginService: LoginserviceService, public router: Router, private route: ActivatedRoute,
    private confirmationDialogService: ConfirmationDialogService, private productFindService: NgbModal, private toastr: ToastrService, private datePipe: DatePipe) {
    this.fnServiceChanges();
    this.fnGetParameterVariable();
  }
  //Get Para
  fnGetParameterVariable() {
    this.route.queryParams.subscribe(params => {
      if (params.designationid !== undefined) {
        this.filterdesignationid = params.designationid
        this.filterpayrollgrpid = params.payrollgrpid
        this.filterbranchid = params.branchid
        this.filterdepartmentid = params.departmentid
        this.filterlocationid = params.locationid
        this.filternationalityid = params.nationalityid
        this.filterfromdate = params.fromdate
        this.filtertodate = params.todate
      }
      if (params.designationname !== undefined) {
        this.filterdesignationname = params.designationname
      }
      else if (params.payrollgrpname !== undefined) {
        this.filterpayrollgrpname = params.payrollgrpname
      }
      else if (params.branchname !== undefined) {
        this.filterbranchname = params.branchname
      }
      else if (params.departmentname !== undefined) {
        this.filterdepartmentname = params.departmentpname
      }
      else if (params.locationname !== undefined) {
        this.filterlocationname = params.locationname
      }
      else if (params.nationality !== undefined) {
        this.filternationality = params.nationality
      }
      else if (params.fromdate !== undefined) {
        this.filterfromdate = params.fromdate
      }
      else if (params.todate !== undefined) {
        this.filtertodate = params.todate
      }


      if (params.status !== undefined) {
        this.filterstatus = params.status
      }

    })
  }
  //Company Check
  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        this.fnCheckPrivilage();
        if (this.isview) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }

      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    });
  }

  //Init
  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        this.fnCheckPrivilage();
        if (this.isview) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    this.fngetEmp();
    this.fngetCompanyCheckDet()
  }


  fnCheckPrivilage() {

    this.isadd = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE');
    this.isedit = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER');
    this.isdelete = this.loginService.fnCheckUserRoleAction(this.formname, 'DELETE');
    this.isview = this.loginService.fnCheckUserRoleAction(this.formname, 'VIEW');
    this.isprint = this.loginService.fnCheckUserRoleAction(this.formname, 'PRINT');
    this.isexport = this.loginService.fnCheckUserRoleAction(this.formname, 'EXPORT');


  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }

  onRowDoubleClick(data) {



    this.fnEditForm(data.empid);
  }



  //Event  
  fnActionEditClick(data) {




    this.fnEditForm(data.empid);
  }



  fnActionDeleteClick(data) {

    this.fnDeleteConfirm(data.empid, data.empname);
  }


  fnActionExportClick() {
    const params = {
      columnGroups: true,
      allColumns: true,
      fileName: 'Employeelist',
      //columnSeparator: document.querySelector("#columnSeparator").value
    };
    // this.gridApi.exportDataAsCsv(params);
  }

  fnActionFilterClick() {

    // this.filterbar.filterstatus = this.filterstatus;

    // this.isfilter = !this.isfilter;
    this.fnShowFilterPopup();
  }
  fnActionRefreshClick() {
    this.fngetEmp()
  }
  fnApplyFilter(data) {
    // this.isfilter = !this.isfilter;

    this.filterstatus = data;

    this.fngetEmp();

  }

  fnCurrentRouteChange() {
    var queryParams = {};


    if (this.filterstatus != '') {
      queryParams['status'] = this.filterstatus;
    }

    if (this.filterdesignationid > 0) {
      queryParams['designationid'] = this.filterdesignationid;
    }
    if (this.filterdesignationname != '') {
      queryParams['designationname'] = this.filterdesignationname;
    }
    if (this.filterpayrollgrpid > 0) {
      queryParams['payrollgrpid'] = this.filterpayrollgrpid;
    }
    if (this.filterpayrollgrpname != '') {
      queryParams['payrollgrpname'] = this.filterpayrollgrpname;
    }
    if (this.filterbranchid > 0) {
      queryParams['branchid'] = this.filterbranchid;
    }
    if (this.filterbranchname != '') {
      queryParams['branchname'] = this.filterbranchname;
    }
    if (this.filterdepartmentid > 0) {
      queryParams['departmentid'] = this.filterdepartmentid;
    }
    if (this.filterdepartmentname != '') {
      queryParams['departmentname'] = this.filterdepartmentname;
    }
    if (this.filterlocationid > 0) {
      queryParams['locationid'] = this.filterlocationid;
    }
    if (this.filterlocationname != '') {
      queryParams['locationname'] = this.filterlocationname;
    }
    if (this.filternationalityid > 0) {
      queryParams['nationalityid'] = this.filternationalityid;
    }
    if (this.filternationality != '') {
      queryParams['nationality'] = this.filternationality;
    }
    if (this.filterfromdate > 0) {
      queryParams['fromdate'] = this.filterfromdate;
    }
    if (this.filtertodate != '') {
      queryParams['todate'] = this.filtertodate;
    }

    this.router.navigate(
      [],
      {
        relativeTo: this.route,
        queryParams: queryParams,

      });
  }

  fnApplyFilterPop(data) {

    //this.isfilter = !this.isfilter;
    this.filteremployeeid = data.empid;
    this.filteremployeename = data.empname;
    this.filterdesignationid = data.designationid;
    this.filterdesignationname = data.designationname;
    this.filterpayrollgrpid = data.payrollgrpid;
    this.filterpayrollgrpname = data.payrollgrpname;
    this.filterbranchid = data.branchid;
    this.filterbranchname = data.branchname;
    this.filterdepartmentid = data.departmentid;
    this.filterdepartmentname = data.departmentname;
    this.filterlocationid = data.locationid;
    this.filterlocationname = data.locationname;
    this.filternationalityid = data.nationalityid;
    this.filternationality = data.nationality;
    this.filterfromdate = data.fromdate;
    this.filtertodate = data.todate;
    this.fngetEmp();

  }

  fnRemoveFilter(type) {

    if (type === 'INACTIVE') {
      this.filterstatus = "";
      this.fngetEmp();
    }
    else {
      this.filterstatus = "";
      this.fngetEmp();
    }
  }
  //Get
  fngetEmp() {
    if (this.showProgress) {
      return
    }

    this.fnShowProgress();

    var data = {
      'empid': 0,
      'designationid': this.filterdesignationid,
      'payrollgrpid': this.filterpayrollgrpid,
      'branchid': this.filterbranchid,
      'departmentid': this.filterdepartmentid,
      'locationid': this.filterlocationid,
      'nationalityid': this.filternationalityid,
      'companyid': this.loginService.fnGetCompanyId(),
      'filterstatus': this.filterstatus,
      'fromdate': this.fnFormatDatetime(this.filterfromdate),
      'todate': this.fnFormatDatetime(this.filtertodate),
    }
    this.appService.getEmpListView(data)
      .subscribe(
        (res) => {
          this.fnHideProgress();
          if (res.json().status === 200) {
            this.empColl = res.json().result;
            this.fnSetTable();
            this.fnCurrentRouteChange();

          } else {
            this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.fnHideProgress();
          this.toastr.error('Error', err);
        })
  }

  fngetCompanyCheckDet() {

    var data = {

      'companyid': this.loginService.fnGetCompanyId()
    }
    this.appService.getCompanyCheckDetails(data)
      .subscribe(
        (res) => {

          if (res.json().status === 200) {

            this.companycheckColl = res.json().result[0];

            this.checkemp = this.companycheckColl.employeecheck;

          }

        },
        (err) => {

          this.toastr.error('Error', err);
        })
  }

  fnAddForm() {
    try {
      let navigationExtras: NavigationExtras = {
        queryParams: {
          'status': this.filterstatus,
          'designationid': this.filterdesignationid,
          'designationname': this.filterdesignationname,
          'payrollgrpid': this.filterpayrollgrpid,
          'payrollgrpname': this.filterpayrollgrpname,
          'branchid': this.filterbranchid,
          'branchname': this.filterbranchname,
          'departmentid': this.filterdepartmentid,
          'departmentname': this.filterdepartmentname,
          'locationid': this.filterlocationid,
          'locationname': this.filterlocationname,
          'nationalityid': this.filternationalityid,
          'nationality': this.filternationality,
          'fromdate': this.fnFormatDatetime(this.filterfromdate),
          'todate': this.fnFormatDatetime(this.filtertodate),
        }
      }

      this.router.navigate(['/AddEmpNew'], navigationExtras);

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnEditForm(deptid) {
    try {
      let navigationExtras: NavigationExtras = {
        queryParams: {
          'eid': deptid,
          'status': this.filterstatus,
          'designationid': this.filterdesignationid,
          'designationname': this.filterdesignationname,
          'payrollgrpid': this.filterpayrollgrpid,
          'payrollgrpname': this.filterpayrollgrpname,
          'branchid': this.filterbranchid,
          'branchname': this.filterbranchname,
          'departmentid': this.filterdepartmentid,
          'departmentname': this.filterdepartmentname,
          'locationid': this.filterlocationid,
          'locationname': this.filterlocationname,
          'nationalityid': this.filternationalityid,
          'nationality': this.filternationality,
          'fromdate': this.fnFormatDatetime(this.filterfromdate),
          'todate': this.fnFormatDatetime(this.filtertodate),
        }
      }

      this.router.navigate(['/EmpView'], navigationExtras);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnImportBtn() {

    const modalRef = this.productFindService.open(ImportemployeeComponent, { size: <any>'l' });



    // modalRef.componentInstance.emitData.subscribe((receivedEntry) => {


    // });

  }
  fnShowFilterPopup() {

    const modalRef = this.productFindService.open(EmpfilterComponent, { size: <any>'l' });
    modalRef.componentInstance.formname = this.formname;
    modalRef.componentInstance.designationid = !this.filterdesignationid ? null : Number(this.filterdesignationid);
    modalRef.componentInstance.payrollgrpid = !this.filterpayrollgrpid ? null : Number(this.filterpayrollgrpid);
    modalRef.componentInstance.branchid = !this.filterbranchid ? null : Number(this.filterbranchid);
    modalRef.componentInstance.departmentid = !this.filterdepartmentid ? null : Number(this.filterdepartmentid);
    modalRef.componentInstance.locationid = !this.filterlocationid ? null : Number(this.filterlocationid);
    modalRef.componentInstance.nationalityid = !this.filternationalityid ? null : Number(this.filternationalityid);
    modalRef.componentInstance.fromdate = this.filterfromdate;
    modalRef.componentInstance.todate = this.filtertodate;
    // modalRef.componentInstance.fromdate = this.filterfromdate;
    // modalRef.componentInstance.todate = this.filtertodate;

    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      console.log(receivedEntry)

      if (receivedEntry.status === 'DONE') {
        this.filterdesignationid = receivedEntry.designationid;
        this.filterdesignationname = receivedEntry.designationname;
        this.filterpayrollgrpid = receivedEntry.payrollgrpid;
        this.filterpayrollgrpname = receivedEntry.payrollgrpname;
        this.filterbranchid = receivedEntry.branchid;
        this.filterbranchname = receivedEntry.branchname;
        this.filterdepartmentid = receivedEntry.departmentid;
        this.filterdepartmentname = receivedEntry.departmentname;
        this.filterlocationid = receivedEntry.locationid;
        this.filterlocationname = receivedEntry.locationname;
        this.filternationalityid = receivedEntry.nationalityid;
        this.filternationality = receivedEntry.nationality;
        this.filterfromdate = receivedEntry.fromdate;
        this.filtertodate = receivedEntry.todate;
        this.fngetEmp();
      }


    });
  }

  // fnEditForm(deptid) {
  //   try {
  //     let navigationExtras: NavigationExtras = {
  //       queryParams: {
  //         'eid': deptid,
  //       }
  //     }

  //     this.router.navigate(['/EmpView'], navigationExtras);
  //   } catch (ex) {
  //     this.fnShowErrorMsg(ex);
  //   }
  // }

  public fnDeleteConfirm(deptid, reftxt) {
    try {
      this.confirmationDialogService.confirm('Confirm..', 'Do you  want to delete emp?', reftxt)
        .then((confirmed) => {
          if (confirmed) {
            this.fnDeleteForm(deptid, reftxt)
          }
        }
        );
      //.catch(() => );
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  private fnDeleteForm(deptid, reftxt) {
    var data = {
      'empid': deptid,
    }
    this.appService.fnDeleteEmp(data)
      .subscribe(
        (res) => {

          if (res.json().status === 200) {
            this.toastr.success('', " The emp has been deleted successfully.");
            this.fnInsertActivityLog('DELETE', deptid, reftxt);
            this.fngetEmp();
          }
          else {
            this.loginService.fnAPIError(res.json())
          }

        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  private fnExport() {


    const modalRef = this.productFindService.open(ExportgridComponent, { size: <any>'xxl', backdrop: 'static' });
    modalRef.componentInstance.doctype = this.formname;
    modalRef.componentInstance.columnDefs = this.columnDefs;
    modalRef.componentInstance.contentColl = this.empColl;
    modalRef.componentInstance.fnSetTable();
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {


    });

    //  var data = {
    //     data: this.empColl,
    //     columnDefs: this.columnDefs,
    //     title:'Employee Report'
    //   };


    //   this.excelService.generateExcel(data);

    // const modalRef = this.productFindService.open(ExportgridComponent, { size: <any>'xxl', backdrop: 'static' });
    // modalRef.componentInstance.doctype = this.formname;
    // modalRef.componentInstance.columnDefs = this.columnDefs;
    // modalRef.componentInstance.contentColl = this.empColl;
    // modalRef.componentInstance.fnSetTable();
    // modalRef.componentInstance.emitData.subscribe((receivedEntry) => {


    // });

  }

  public fnSearchDatatable(value) {
    this.gridOptions.pageindex = 1
    //this.gridApi.setQuickFilter(value);
  }
  fnResetGrid(data) {
    this.searchtxt = data;
    this.gridOptions.pageindex = 1
  }
  fnSetTable() {

  }

  private fnFocusTableRow(index, status) {
    if (index > -1) {
      if (status === 'IN') {
        this.empColl[index].hoverfocus = "IN"
      }
      else {
        this.empColl[index].hoverfocus = ""
      }
    }
  }

  fnTabHeaderClick(type) {
    this.searchtxt = "";
    this.gridformtype = type;
  }
  fnMomentDateFormatter(params) {
    if (params.value) {
      return moment(params.value).format('DD-MM-YYYY');//  
    }
    else {
      return '';
    }

  }

  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }
  }
  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }
  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }

  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }








}
